export default {
  layerManager: {
    appendTo: '.layers-container',
  },
}
